import { Component } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
    selector: 'fn-grid-color',
    templateUrl: 'fn-grid-color.component.html',
    styleUrls: ['fn-grid-color.component.scss'],
})
export class FnGridColorComponent extends FnGridAbstractCell {
    constructor() {
        super();
    }

    override changeAction(colorVal: string) {
        this.cellValue = colorVal;
        this.editToggle();
        this.cellValueChange.emit(this.cellValue);
    }
}
